/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { passwordsControllerForgot } from "./passwordsControllerForgot";
import { passwordsControllerReset } from "./passwordsControllerReset";

export function passwordsService() {
  return { passwordsControllerForgot, passwordsControllerReset }
}